import React, { useState, useEffect } from "react";
import "./TablesSection.css";

export default function TablesSection({ restaurant }) {
  const [tables, setTables] = useState([]);
  const [tableNumber, setTableNumber] = useState("");
  const [status, setStatus] = useState("free");
  const [error, setError] = useState("");

  useEffect(() => {
    if (restaurant) {
      fetchTables();
    }
    // eslint-disable-next-line
  }, [restaurant]);

  const fetchTables = async () => {
    setError("");
    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/tables?restaurant_id=${restaurant.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) {
        throw new Error("Errore durante il caricamento dei tavoli");
      }
      const data = await res.json();
      setTables(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const handleCreateTable = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const token = localStorage.getItem("access_token");
      const payload = {
        table_number: parseInt(tableNumber, 10),
        status,
        restaurant_id: restaurant.id,
      };
      const res = await fetch(`${process.env.REACT_APP_API_URL}/tables`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore creazione tavolo");
      }
      const newTable = await res.json();
      setTables((prev) => [...prev, newTable]);
      setTableNumber("");
      setStatus("free");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="tables-section-container">
      <div className="tables-header">
        <h3 className="section-title">Tavoli</h3>
      </div>

      {error && <p className="error-text">{error}</p>}

      {/* Form di creazione in alto */}
      <form className="table-form" onSubmit={handleCreateTable}>
        <div className="form-row">
          <input
            type="number"
            placeholder="Numero tavolo"
            value={tableNumber}
            onChange={(e) => setTableNumber(e.target.value)}
            required
            className="table-input"
          />
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="table-select"
          >
            <option value="free">Libero</option>
            <option value="occupied">Occupato</option>
          </select>
        </div>
        <button type="submit" className="create-table-btn">
          Crea Tavolo
        </button>
      </form>

      <div className="tables-list-container">
        {tables.length === 0 ? (
          <p className="no-tables-text">Nessun tavolo per questo ristorante.</p>
        ) : (
          <ul className="table-list">
            {tables.map((t) => (
              <li key={t.id} className="table-item">
                <div className="table-info">
                  <span className="table-number">Tavolo {t.table_number}</span>
                  <span className={`table-status ${t.status}`}>
                    {t.status === "free" ? "Libero" : "Occupato"}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
